import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  return <motion.a href={href || '#'} target={href ? '_blank' : undefined} rel={href ? 'noopener noreferrer' : undefined} onClick={e => {
    if (!href) {
      e.preventDefault();
    }
    try {
      onClick?.();
    } catch (err) {
      // Never block navigation
    }
  }} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-neutral-950 font-bold text-lg py-4 px-8 rounded-lg shadow-[0_0_20px_rgba(245,158,11,0.2)] hover:shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-colors ${className}`} data-id="element-176">
      {children}
      <Download className="w-5 h-5" data-id="element-177" />
    </motion.a>;
}